import { Route } from '../Types/Route';
import { dashboardRoutes } from './dashboard';

// Layouts
import DashboardLayout from '../Views/Layout';

// routes
import Login from '../Views/login/Login';
import Page404 from '../Views/Pages/Page404';

export const mainRoutes: Route[] = [
	{
		name: 'login',
		title: 'ورود',
		path: '/login',
		sidebar: false,
		component: Login,
		private: false,
	},
	{
		name: 'dashboard',
		title: 'داشبورد',
		path: '/',
		sidebar: false,
		component: DashboardLayout,
		routes: dashboardRoutes,
		private: true,
	},
	{
		name: 'notFound',
		title: 'یافت نشد',
		sidebar: false,
		component: Page404,
		private: false,
	},
];
